import { render, staticRenderFns } from "./comment-unit.vue?vue&type=template&id=efef21de&scoped=true"
import script from "./comment-unit.vue?vue&type=script&lang=js"
export * from "./comment-unit.vue?vue&type=script&lang=js"
import style0 from "./comment-unit.vue?vue&type=style&index=0&id=efef21de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efef21de",
  null
  
)

export default component.exports